/**
 * Consistent spacing scale for the app.
 */
export const SPACING = { xs: 4, sm: 8, md: 14, lg: 20, xl: 28 };

/**
 * Shared inline-style presets used across the app.
 * These are theme-agnostic base styles; theme colors are applied at the call site.
 */
export const S = {
  card: {
    background: "white",
    borderRadius: 14,
    padding: 18,
    boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    border: "1px solid #eee",
  },
  input: {
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "9px 12px",
    fontSize: 13,
    boxSizing: "border-box",
    outline: "none",
    transition: "border 0.2s",
  },
  select: {
    width: "100%",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "9px 12px",
    fontSize: 13,
    background: "white",
    boxSizing: "border-box",
    outline: "none",
  },
  btn: (bg = "#2563eb") => ({
    background: bg,
    color: "white",
    border: "none",
    borderRadius: 8,
    padding: "10px 20px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer",
    transition: "opacity 0.2s",
  }),
  btnSm: (bg = "#2563eb") => ({
    background: bg,
    color: "white",
    border: "none",
    borderRadius: 8,
    padding: "7px 14px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
  }),
  link: (c) => ({
    background: "none",
    border: "none",
    color: c,
    cursor: "pointer",
    fontSize: 12,
    minHeight: 44,
    display: "inline-flex",
    alignItems: "center",
  }),
  th: {
    textAlign: "left",
    padding: "10px 10px",
    fontSize: 10,
    fontWeight: 700,
    color: "#9ca3af",
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 700,
    color: "#9ca3af",
    textTransform: "uppercase",
    letterSpacing: 0.8,
    marginBottom: 14,
  },
};
